import { confirm } from '@magicdoorinc/ui';

type Translate = (key: string, params?: Record<string, string>) => string;

export const confirmDeleteBill = (t: Translate, handler: () => Promise<void>) => {
  const { resolve, promise, reject } = Promise.withResolvers();
  confirm({
    title: t('Delete bill'),
    content: (
      <p class="mt-4">
        {t(
          'Deleting {type} will only delete the accounting entries for the {type}, if an ACH payment was sent out it will not be pulled back',
          { type: t('bill') }
        )}
      </p>
    ),
    onResolve: async (confirmed) => {
      if (!confirmed) return reject(undefined);
      try {
        await handler();
        return resolve(undefined);
      } catch (error) {
        return reject(error);
      }
    },
  });
  return promise;
};
